import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
//
import ReactApexChart from "react-apexcharts";
import { Card } from "react-bootstrap";

function CostChart({ chartData }) {
  const colors = ["#fff", "#e6fbf3", "#2FDB9D"];
  const [key, setKey] = useState(0);
  const [option, setOption] = useState({
    series: [
      {
        name: "BTC Invesment",
        type: "area",
        data: [],
      },
      {
        name: "USD Invesment",
        type: "line",
        data: [],
      },
    ],
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    labels: [],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    markers: {
      size: 2,
      hover: {
        size: 4,
      },
      colors: ["#63e4b5", "#F9A643"],
    },
    stroke: {
      curve: "straight",
      colors: ["#63e4b5", "#F9A643"],
      width: 2,
    },
    xaxis: {
      labels: {
        style: {
          colors: "#B4B9C0",
        },
      },
      tickAmount: 6,
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      tickAmount: 10,
      floating: false,

      labels: {
        style: {
          colors: "#E6E8EA",
        },
        offsetY: 0,
        offsetX: -16,
        formatter: (value) => {
          return value;
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    fill: {
      type: "gradient",
      colors: ["#2FDB9D"],
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.1,
        opacityTo: 0.9,
        stops: [0, 90, 95],
        colors: colors,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      enabled: true,
      marker: {
        show: false,
      },
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return "$" + y.toFixed(0);
          }
          return y;
        },
      },
    },
    grid: {
      padding: {
        left: 0,
        right: 0,
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
  });

  useEffect(() => {
    let chart = { ...option };
    chart.series[0].data = chartData.investment;
    chart.series[1].data = chartData.principal;
    chart.labels = chartData.labels;

    setOption(chart);

    setKey(key + 1);
  }, [chartData]);

  return (
    <ReactApexChart
      key={key}
      options={option}
      series={option.series}
      type="area"
      height={450}
    />
  );
}

CostChart.propTypes = {};

export default CostChart;
